(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports', 'react'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react);
        global.index = mod.exports;
    }
})(this, function (exports, _react) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.EasterEgg = exports.KONAMI_CODE = undefined;

    var _react2 = _interopRequireDefault(_react);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var KONAMI_CODE = exports.KONAMI_CODE = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65];

    var EasterEgg = exports.EasterEgg = function (_React$Component) {
        _inherits(EasterEgg, _React$Component);

        function EasterEgg() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, EasterEgg);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EasterEgg.__proto__ || Object.getPrototypeOf(EasterEgg)).call.apply(_ref, [this].concat(args))), _this), _this.state = { index: 0 }, _this.handleKeyDown = function (event) {
                var _this$props = _this.props;
                var callback = _this$props.callback;
                var disable = _this$props.disable;
                var code = _this$props.code;

                var sequence = code || KONAMI_CODE;

                if (_this.state.index < sequence.length) {
                    var nextIndex = void 0;

                    if (event.keyCode === sequence[_this.state.index]) {
                        nextIndex = _this.state.index + 1;
                    } else {
                        nextIndex = 0;
                    }

                    _this.setState({ index: nextIndex });

                    if (!disable && nextIndex === sequence.length) {
                        callback && callback();
                    }
                }
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(EasterEgg, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                document.addEventListener('keydown', this.handleKeyDown);
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.handleKeyDown);
            }
        }, {
            key: 'render',
            value: function render() {
                var _props = this.props;
                var children = _props.children;
                var className = _props.className;
                var disable = _props.disable;
                var code = _props.code;

                var sequence = code || KONAMI_CODE;

                return !disable && this.state.index === sequence.length ? _react2.default.createElement(
                    'div',
                    { className: className || '' },
                    children
                ) : null;
            }
        }]);

        return EasterEgg;
    }(_react2.default.Component);

    EasterEgg.propTypes = {
        children: _react2.default.PropTypes.element,
        className: _react2.default.PropTypes.string,
        disable: _react2.default.PropTypes.bool,
        callback: _react2.default.PropTypes.func,
        code: _react2.default.PropTypes.array
    };

    exports.default = EasterEgg;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-easter-egg/dist/index.js
// module id = 219
// module chunks = 0